import type React from 'react';

import { SearchLoadingSkeleton } from '@xing-com/crate-search-utils';
import { NoSSRLoggedInSuspense } from '@xing-com/crate-utils-no-ssr';

import { Container } from './container';
export const Component: React.FC = () => (
  <NoSSRLoggedInSuspense fallback={<SearchLoadingSkeleton />}>
    <Container />
  </NoSSRLoggedInSuspense>
);
